<template>
<div class="comps-for-inventory row-center-start">
  <div class="cfi-radio-group">
    <el-radio-group v-model="btnActive" @change="initDatePicker()">
      <el-radio-button label="week">近一周</el-radio-button>
      <el-radio-button label="month">近一月</el-radio-button>
      <!-- <el-radio-button label="year">近一年</el-radio-button> -->
    </el-radio-group>
  </div>
  <div>
    查询日期：
    <el-date-picker style="width: 260px;" v-model="dateRange" @change="pickerChange()" :clearable="false" value-format="YYYY-MM-DD" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
  </div>
</div>
</template>

<script>
import { computed, onMounted, reactive, ref, toRefs } from 'vue';
import { ElMessage } from 'element-plus';
export default {
  setup(props, ctx) {
    const state = reactive({
      btnActive: "week",
      tempRange: [],
      endDate: computed(() => {
        if (state.btnActive == "") {
          return state.tempRange[1];
        } else {
          // 格式化日期
          let today = new Date(),
            year = today.getFullYear(),
            month = today.getMonth() + 1,
            day = today.getDate();
          return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
        }
      }),
      startDate: computed(() => {
        let today = new Date();
        // 判断当前按钮类别，格式化时间
        if (state.btnActive == "week") {
          // 近一周
          let wDate = new Date(today - 6 * 24 * 3600 * 1000),
            year = wDate.getFullYear(),
            month = wDate.getMonth() + 1,
            day = wDate.getDate();
          return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
        } else if (state.btnActive == "month") {
          // 近一月
          let mDate = new Date(today.setMonth(today.getMonth() - 1)),
            year = mDate.getFullYear(),
            month = mDate.getMonth() + 1,
            day = mDate.getDate();
          return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
        } else if (state.btnActive == "year") {
          // 近一年
          let yDate = new Date(today.setFullYear(today.getFullYear() - 1)),
            year = yDate.getFullYear(),
            month = yDate.getMonth() + 1,
            day = yDate.getDate();
          return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
        } else {
          return state.tempRange[0];
        }
      })
    });

    // 时间区间
    let dateRange = ref(computed({
      get() { return [state.startDate, state.endDate] },
      set(e) {
        state.btnActive = "";
        state.tempRange = e;
      }
    }));

    onMounted(() => {
      // initDatePicker();
    });

    // 日期选择事件
    const pickerChange = () => {
      let start = state.tempRange[0],
        end = state.tempRange[1],
        countDay = new Date(end).getTime() - new Date(start).getTime();
      if (countDay / 86400000 > 30) {
        ElMessage.warning("请勿选择超过一个月");
      } else {
        state.btnActive = "";
        ctx.emit("dateChange", state.btnActive);
      }
    }

    // datePicker赋值
    const initDatePicker = () => {
      let today = new Date(),
        year = today.getFullYear(),
        month = today.getMonth() + 1,
        day = today.getDate(),
        endDate = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day),
        startDate;
      if (state.btnActive == "week") {
        let wDate = new Date(today - 6 * 24 * 3600 * 1000),
          year = wDate.getFullYear(),
          month = wDate.getMonth() + 1,
          day = wDate.getDate();
        startDate = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
      } else if (state.btnActive == "month") {
        let mDate = new Date(today.setMonth(today.getMonth() - 1)),
          year = mDate.getFullYear(),
          month = mDate.getMonth() + 1,
          day = mDate.getDate();
        startDate = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
      } else {
        let yDate = new Date(today.setFullYear(today.getFullYear() - 1)),
          year = yDate.getFullYear(),
          month = yDate.getMonth() + 1,
          day = yDate.getDate();
        startDate = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
      }

      dateRange = ref([startDate, endDate]);
      ctx.emit("dateChange", state.btnActive);
    };

    return {
      ...toRefs(state),
      initDatePicker,
      pickerChange,
      dateRange,
    }
  }
}
</script>

<style lang="scss" scoped>
.comps-for-inventory {
  .cfi-radio-group {
    margin-right: 14px;
  }
}
</style>
